import { createSlice } from "@reduxjs/toolkit";
import { deleteProject, getDepartmentDetails, getMilestone, getProjDetail, getProjectList, getProjectManager, getProjectMemberList, saveMilestone, saveProject, saveProjectMember, saveProjectTask, saveProjectDeliverable,
     deleteDeliverable,deleteProjectTask,deleteMilestone,deleteProjectMember,uploadDeliverableDoc,downloadDeliverableDoc, deleteDeliverableDoc } from "../../actions/project-management/ProjectAction";


const initialState = {
    loading: false,
    prjListData: null,
    error: null,
    success: false,
    //dropdown
    loading1: false,
    memberList: null,
    error1: null,
    success1: false,
    //save project
    loading2: false,
    prjInfo: null,
    error2: null,
    success2: false,
    //department details
    loading3: false,
    deptInfo: null,
    error3: null,
    success3: false,
    //get proj detail
    loading4: false,
    prjdetailInfo: null,
    error4: null,
    success4: false,
    //save member
    loading5: false,
    memberInfo: null,
    error5: null,
    success5: false,
    //get project manager
    loading6: false,
    prjManagerInfo: null,
    error6: null,
    success6: false,
    //get milestone
    loading7: false,
    milestoneInfo: null,
    error7: null,
    success7: false,
    //delete project
    loading8: false,
    delPrjInfo: null,
    error8: null,
    success8: false,
    // project task
    loading9: false,
    savetaskInfo: null,
    error9: null,
    success9: false,
    //save milestone
    loading10: false,
    saveMileInfo: null,
    error10: null,
    success10: false,
    //save deliverable
    loading11: false,
    saveDilInfo: null,
    error11: null,
    success11: false,
    //delete deliverable
    loading12: false,
    deleteDilInfo: null,
    error12: null,
    success12: false,
    // delete project task
    loading13: false,
    deletetaskInfo: null,
    error13: null,
    success13: false,
    // delete milestone
    loading14: false,
    deleteMileInfo: null,
    error14: null,
    success14: false,
    // delete team member
    loading15: false,
    deletePrjMem: null,
    error15: null,
    success15: false,
    // upload deliverble document
    loading16: false,
    uploadDlvDoc: null,
    error16: null,
    success16: false,
    // download deliverble document
    loading17: false,
    downloadDlvDoc: null,
    error17: null,
    success17: false,
    // delete deliverble document
    loading18: false,
    deleteDlvDoc: null,
    error18: null,
    success18: false,
}

const projectSlice = createSlice({
    name: "project-list",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getProjectList.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(getProjectList.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.prjListData = payload;
                state.success = true;
                state.error = null;
            })
            .addCase(getProjectList.rejected, (state, { paylaod }) => {
                state.loading = false;
                state.error = paylaod;
                state.success = false;
            })
            //get member list
            .addCase(getProjectMemberList.pending, (state) => {
                state.loading1 = true;
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(getProjectMemberList.fulfilled, (state, { payload }) => {
                state.loading1 = false;
                state.memberList = payload;
                state.success1 = true;
                state.error1 = null;
            })
            .addCase(getProjectMemberList.rejected, (state, { paylaod }) => {
                state.loading1 = false;
                state.error1 = paylaod;
                state.success1 = false;
            })
            //get project detail
            .addCase(getProjDetail.pending, (state) => {
                state.loading4 = true;
                state.error4 = null;
                state.success4 = false;
            })
            .addCase(getProjDetail.fulfilled, (state, { payload }) => {
                state.loading4 = false;
                state.prjdetailInfo = payload;
                state.success4 = true;
                state.error4 = null;
            })
            .addCase(getProjDetail.rejected, (state, { paylaod }) => {
                state.loading4 = false;
                state.error4 = paylaod;
                state.success4 = false;
            })
            //save project
            .addCase(saveProject.pending, (state) => {
                state.loading2 = true;
                state.error2 = null;
                state.success2 = false;
            })
            .addCase(saveProject.fulfilled, (state, { payload }) => {
                state.loading2 = false;
                state.prjInfo = payload;
                state.success2 = true;
                state.error2 = null;
            })
            .addCase(saveProject.rejected, (state, { paylaod }) => {
                state.loading2 = false;
                state.error2 = paylaod;
                state.success2 = false;
            })
            //get department details
            .addCase(getDepartmentDetails.pending, (state) => {
                state.loading3 = true;
                state.error3 = null;
                state.success3 = false;
            })
            .addCase(getDepartmentDetails.fulfilled, (state, { payload }) => {
                state.loading3 = false;
                state.deptInfo = payload;
                state.success3 = true;
                state.error3 = null;
            })
            .addCase(getDepartmentDetails.rejected, (state, { paylaod }) => {
                state.loading3 = false;
                state.error3 = paylaod;
                state.success3 = false;
            })
            //save project memebr
            .addCase(saveProjectMember.pending, (state) => {
                state.loading5 = true;
                state.error5 = null;
                state.success5 = false;
            })
            .addCase(saveProjectMember.fulfilled, (state, { payload }) => {
                state.loading5 = false;
                state.memberInfo = payload;
                state.success5 = true;
                state.error5 = null;
            })
            .addCase(saveProjectMember.rejected, (state, { paylaod }) => {
                state.loading5 = false;
                state.error5 = paylaod;
                state.success5 = false;
            })
            //project maanger
            .addCase(getProjectManager.pending, (state) => {
                state.loading6 = true;
                state.error6 = null;
                state.success6 = false;
            })
            .addCase(getProjectManager.fulfilled, (state, { payload }) => {
                state.loading6 = false;
                state.prjManagerInfo = payload;
                state.success6 = true;
                state.error6 = null;
            })
            .addCase(getProjectManager.rejected, (state, { paylaod }) => {
                state.loading6 = false;
                state.error6 = paylaod;
                state.success6 = false;
            })
            //get milestone
            .addCase(getMilestone.pending, (state) => {
                state.loading7 = true;
                state.error7 = null;
                state.success7 = false;
            })
            .addCase(getMilestone.fulfilled, (state, { payload }) => {
                state.loading7 = false;
                state.milestoneInfo = payload;
                state.success7 = true;
                state.error7 = null;
            })
            .addCase(getMilestone.rejected, (state, { paylaod }) => {
                state.loading7 = false;
                state.error7 = paylaod;
                state.success7 = false;
            })
            //delete project
            .addCase(deleteProject.pending, (state) => {
                state.loading8 = true;
                state.error8 = null;
                state.success8 = false;
            })
            .addCase(deleteProject.fulfilled, (state, { payload }) => {
                state.loading8 = false;
                state.delPrjInfo = payload;
                state.success8 = true;
                state.error8 = null;
            })
            .addCase(deleteProject.rejected, (state, { paylaod }) => {
                state.loading8 = false;
                state.error8 = paylaod;
                state.success8 = false;
            })
            // project task save
            .addCase(saveProjectTask.pending, (state) => {
                state.loading9 = true;
                state.error9 = null;
                state.success9 = false;
            })
            .addCase(saveProjectTask.fulfilled, (state, { payload }) => {
                state.loading9 = false;
                state.savetaskInfo = payload;
                state.success9 = true;
                state.error9 = null;
            })
            .addCase(saveProjectTask.rejected, (state, { paylaod }) => {
                state.loading9 = false;
                state.error9 = paylaod;
                state.success9 = false;
            })
             // project milestone save
             .addCase(saveMilestone.pending, (state) => {
                state.loading10 = true;
                state.error10 = null;
                state.success10 = false;
            })
            .addCase(saveMilestone.fulfilled, (state, { payload }) => {
                state.loading10 = false;
                state.saveMileInfo = payload;
                state.success10 = true;
                state.error10 = null;
            })
            .addCase(saveMilestone.rejected, (state, { paylaod }) => {
                state.loading10 = false;
                state.error10 = paylaod;
                state.success10 = false;
            })
             //save project deliverable
             .addCase(saveProjectDeliverable.pending, (state) => {
                state.loading11 = true;
                state.error11 = null;
                state.success11 = false;
            })
            .addCase(saveProjectDeliverable.fulfilled, (state, { payload }) => {
                state.loading11 = false;
                state.saveDilInfo = payload;
                state.success11 = true;
                state.error11 = null;
            })
            .addCase(saveProjectDeliverable.rejected, (state, { paylaod }) => {
                state.loading11 = false;
                state.error11 = paylaod;
                state.success11 = false;
            })
            //delete project deliverable
            .addCase(deleteDeliverable.pending, (state) => {
                state.loading12 = true;
                state.error12 = null;
                state.success12 = false;
            })
            .addCase(deleteDeliverable.fulfilled, (state, { payload }) => {
                state.loading12 = false;
                state.deleteDilInfo = payload;
                state.success12 = true;
                state.error12 = null;
            })
            .addCase(deleteDeliverable.rejected, (state, { paylaod }) => {
                state.loading12 = false;
                state.error12 = paylaod;
                state.success12 = false;
            })
             //delete project task
            .addCase(deleteProjectTask.pending, (state) => {
                state.loading13 = true;
                state.error13 = null;
                state.success13 = false;
            })
            .addCase(deleteProjectTask.fulfilled, (state, { payload }) => {
                state.loading13 = false;
                state.deletetaskInfo = payload;
                state.success13 = true;
                state.error13 = null;
            })
            .addCase(deleteProjectTask.rejected, (state, { paylaod }) => {
                state.loading13 = false;
                state.error13 = paylaod;
                state.success13 = false;
            })
             //delete Milestone
             .addCase(deleteMilestone.pending, (state) => {
                state.loading14 = true;
                state.error14 = null;
                state.success14 = false;
            })
            .addCase(deleteMilestone.fulfilled, (state, { payload }) => {
                state.loading14 = false;
                state.deleteMileInfo = payload;
                state.success14 = true;
                state.error14 = null;
            })
            .addCase(deleteMilestone.rejected, (state, { paylaod }) => {
                state.loading14 = false;
                state.error14 = paylaod;
                state.success14 = false;
            })
             //delete project team member
             .addCase(deleteProjectMember.pending, (state) => {
                state.loading15 = true;
                state.error15 = null;
                state.success15 = false;
            })
            .addCase(deleteProjectMember.fulfilled, (state, { payload }) => {
                state.loading15 = false;
                state.deletePrjMem = payload;
                state.success15 = true;
                state.error15 = null;
            })
            .addCase(deleteProjectMember.rejected, (state, { paylaod }) => {
                state.loading15 = false;
                state.error15 = paylaod;
                state.success15 = false;
            })
              //upload deliverble document
            .addCase(uploadDeliverableDoc.pending, (state) => {
                state.loading16 = true;
                state.error16 = null;
                state.success16 = false;
            })
            .addCase(uploadDeliverableDoc.fulfilled, (state, { payload }) => {
                state.loading16 = false;
                state.uploadDlvDoc = payload;
                state.success16 = true;
                state.error16 = null;
            })
            .addCase(uploadDeliverableDoc.rejected, (state, { paylaod }) => {
                state.loading16 = false;
                state.error16 = paylaod;
                state.success16 = false;
            })
            //download deliverble document
            .addCase(downloadDeliverableDoc.pending, (state) => {
                state.loading17 = true;
                state.error17 = null;
                state.success17 = false;
            })
            .addCase(downloadDeliverableDoc.fulfilled, (state, { payload }) => {
                state.loading17 = false;
                state.downloadDlvDoc = payload;
                state.success17 = true;
                state.error17 = null;
            })
            .addCase(downloadDeliverableDoc.rejected, (state, { paylaod }) => {
                state.loading17 = false;
                state.error17 = paylaod;
                state.success17 = false;
            })
            //delete deliverble document
            .addCase(deleteDeliverableDoc.pending, (state) => {
                state.loading18 = true;
                state.error18 = null;
                state.success18 = false;
            })
            .addCase(deleteDeliverableDoc.fulfilled, (state, { payload }) => {
                state.loading18 = false;
                state.deleteDlvDoc = payload;
                state.success18 = true;
                state.error18 = null;
            })
            .addCase(deleteDeliverableDoc.rejected, (state, { paylaod }) => {
                state.loading18 = false;
                state.error18 = paylaod;
                state.success18 = false;
            })
    }
});

export default projectSlice.reducer;